export default "__VITE_ASSET__B6bGyC_v__"